import { render, staticRenderFns } from "./addCharge.vue?vue&type=template&id=3060d620&"
import script from "./addCharge.vue?vue&type=script&lang=js&"
export * from "./addCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3060d620')) {
      api.createRecord('3060d620', component.options)
    } else {
      api.reload('3060d620', component.options)
    }
    module.hot.accept("./addCharge.vue?vue&type=template&id=3060d620&", function () {
      api.rerender('3060d620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/houseDeliveryManage/decorationRegistration/addCharge.vue"
export default component.exports